module.exports = __webpack_public_path__ + "img/no-result.db144d61.svg";